import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  storePassportPhotos,
  storeAirticketsPhotos,
  deletePassportOrAirTicket,
  reserve,
  getAllReservations,
  getAllDrivers,
  reserveDriver,
  sendEmail,
  cancelEmail,
  storeConfirmationPhotos,
  storeInvoicePhotos,
  storePaymentPhotos,
  deleteHotelDocoments,
  setInvoicePrice,
  setPaymentPrice,
  reserveTourguide,
} from "./reserveAxios";

// Reserve
export const Reserve = createAsyncThunk(
  "reserve/reserve",
  async (data, thunkAPI) => {
    try {
      return reserve(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Store Passport Photos
export const StorePassportPhotos = createAsyncThunk(
  "reserve/add-passports",
  async (data, thunkAPI) => {
    try {
      return storePassportPhotos(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Store Airtickets Photos
export const StoreAirticketsPhotos = createAsyncThunk(
  "reserve/airtickets",
  async (data, thunkAPI) => {
    try {
      return storeAirticketsPhotos(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Passport Or AirTicket
export const DeletePassportOrAirTicket = createAsyncThunk(
  "reserve/delete-passport-airticket",
  async (data, thunkAPI) => {
    try {
      return deletePassportOrAirTicket(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Store Airtickets Photos
export const GetAllReservations = createAsyncThunk(
  "reserve/get-all-resrvations",
  async (id, thunkAPI) => {
    try {
      return getAllReservations(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get All Drivers
export const GetAllDrivers = createAsyncThunk(
  "reserve/get-all-drivers",
  async (data, thunkAPI) => {
    try {
      return getAllDrivers(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// Reserve Driver
export const ReserveDriver = createAsyncThunk(
  "reserve/reserve-driver",
  async (data, thunkAPI) => {
    try {
      return reserveDriver(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Reserve Tourguide
export const ReserveTourguide = createAsyncThunk(
  "reserve/reserve-Tourguide",
  async (data, thunkAPI) => {
    try {
      return reserveTourguide(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Send Email
export const SendEmail = createAsyncThunk(
  "reserve/send-email",
  async (data, thunkAPI) => {
    try {
      return sendEmail(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Cancel Email
export const CancelEmail = createAsyncThunk(
  "reserve/cancel-email",
  async (data, thunkAPI) => {
    try {
      return cancelEmail(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Store Confirmation Photos
export const StoreConfirmationPhotos = createAsyncThunk(
  "reserve/add-cofirmations",
  async (data, thunkAPI) => {
    try {
      return storeConfirmationPhotos(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Store Invoice Photos
export const StoreInvoicePhotos = createAsyncThunk(
  "reserve/add-invoices",
  async (data, thunkAPI) => {
    try {
      return storeInvoicePhotos(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Store Payment Photos
export const StorePaymentPhotos = createAsyncThunk(
  "reserve/add-payments",
  async (data, thunkAPI) => {
    try {
      return storePaymentPhotos(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Hotel Docoments
export const DeleteHotelDocoments = createAsyncThunk(
  "reserve/delete-hotel-docoment",
  async (data, thunkAPI) => {
    try {
      return deleteHotelDocoments(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// set invoice price
export const SetInvoicePrice = createAsyncThunk(
  "reserve/set-invoice-price",
  async (data, thunkAPI) => {
    try {
      return setInvoicePrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// set payment price
export const SetPaymentPrice = createAsyncThunk(
  "reserve/set-payment-price",
  async (data, thunkAPI) => {
    try {
      return setPaymentPrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// Define reset state action
export const resetStateOffer = createAction("Reset_all");

const initialState = {
  all_reservations: [],
  all_drivers: [],

  isLoading: false,
  isSuccess: false,
  isReservationsSuccess: false,
  isError: false,
  isCreated: false,
  isDelete: false,
  isEdit: false,
  message: "",
  item: false,
  show: false,
};

// Country Slice
export const offerSlice = createSlice({
  name: "reservation",
  initialState,
  reducers: {
    setItem: (state, { payload }) => {
      state.item = payload;
    },
    resetIsCreated: (state) => {
      state.isCreated = false; // Reset isCreated
    },
    resetIsDelete: (state) => {
      state.isDelete = false; // Reset isCreated
    },
    resetIsEdit: (state) => {
      state.isEdit = false; // Reset isCreated
    },

    resetReservations: (state) => {
      state.isReservationsSuccess = false; // Reset isCreated
    },
  },

  extraReducers: (builder) => {
    builder

      // Edit Day Private Tour
      .addCase(Reserve.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Reserve.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(Reserve.rejected, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = true;
        state.isError = true;

        toast.error("Please Select user");
      })

      // Store Passports Photo
      .addCase(StorePassportPhotos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(StorePassportPhotos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(StorePassportPhotos.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Store Passports Photo
      .addCase(StoreAirticketsPhotos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(StoreAirticketsPhotos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(StoreAirticketsPhotos.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Delete Passport - Airticket Photo
      .addCase(DeletePassportOrAirTicket.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeletePassportOrAirTicket.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(DeletePassportOrAirTicket.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Get All Reservations
      .addCase(GetAllReservations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAllReservations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = true;
        state.all_reservations = action.payload?.data;
        state.isError = false;
      })
      .addCase(GetAllReservations.rejected, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Reserve Driver
      .addCase(ReserveDriver.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(ReserveDriver.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isReservationsSuccess = false;
        state.isEdit = true;
        toast.success(action.payload?.message);
      })
      .addCase(ReserveDriver.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Reserve Tourguide
      .addCase(ReserveTourguide.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(ReserveTourguide.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isReservationsSuccess = false;
        state.isEdit = true;
        toast.success(action.payload?.message);
      })
      .addCase(ReserveTourguide.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Send Email
      .addCase(SendEmail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(SendEmail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isReservationsSuccess = false;
        state.isEdit = true;
        toast.success(action.payload?.message);
      })
      .addCase(SendEmail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Cancel Email
      .addCase(CancelEmail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CancelEmail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isReservationsSuccess = false;
        state.isEdit = true;
        toast.success(action.payload?.message);
      })
      .addCase(CancelEmail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Store Confirmations Photo
      .addCase(StoreConfirmationPhotos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(StoreConfirmationPhotos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(StoreConfirmationPhotos.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Store Invoice Photo
      .addCase(StoreInvoicePhotos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(StoreInvoicePhotos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(StoreInvoicePhotos.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Store Payment Photo
      .addCase(StorePaymentPhotos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(StorePaymentPhotos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(StorePaymentPhotos.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // DeleteHotel Docoments
      .addCase(DeleteHotelDocoments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteHotelDocoments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isReservationsSuccess = false;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(DeleteHotelDocoments.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // SetInvoicePrice
      .addCase(SetInvoicePrice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(SetInvoicePrice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isReservationsSuccess = false;
        state.isEdit = true;
        toast.success(action.payload?.message);
      })
      .addCase(SetInvoicePrice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // SetPaymentPrice
      .addCase(SetPaymentPrice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(SetPaymentPrice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isReservationsSuccess = false;
        state.isEdit = true;
        toast.success(action.payload?.message);
      })
      .addCase(SetPaymentPrice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })
      // Reset state
      .addCase(resetReservations, () => initialState);
  },
});

export default offerSlice.reducer;
export const {
  setItem,
  resetIsCreated,
  resetIsDelete,
  resetIsEdit,
  resetReservations,
} = offerSlice.actions;

export const resetAllReservations = () => (dispatch) => {
  dispatch(resetReservations());
};
